"use strict";

exports.__esModule = true;
exports.default = isDocument;

function isDocument(element) {
  return 'nodeType' in element && element.nodeType === document.DOCUMENT_NODE;
}

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/dom-helpers/cjs/isDocument.js
// module id = 157
// module chunks = 0